/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type FlagState = 'OFF' | 'ON' | 'ABSENT' | unhandledEnumCase;

export type McpRegistryError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'INSERT_ERROR'
  | 'UPDATE_ERROR'
  | 'DELETE_ERROR'
  | 'INVALID_REQUEST'
  | 'NOT_FOUND'
  | 'UNAUTHORIZED'
  | 'USER_ID_NOT_SUPPLIED'
  | 'PORTAL_ID_NOT_SUPPLIED'
  | 'VENDOR_AUTHORIZATION_FAILED'
  | 'VENDOR_CONNECTION_FAILED'
  | unhandledEnumCase;

export type McpServerAuthType =
  | 'OAUTH2'
  | 'URL_BASED'
  | 'OAUTH2_DYNAMIC_URL'
  | unhandledEnumCase;

export type McpServerVisibility =
  | 'INSTALL_REQUIRED'
  | 'GLOBALLY_VISIBLE'
  | unhandledEnumCase;

export type McpServer = {
  id: number;
  authType: McpServerAuthType;
  visibility: McpServerVisibility;
  developerFlagState?: FlagState;
  connected?: boolean;
  authenticatorId: string;
  name: string;
  description: string;
  version?: string;
  enabled: boolean;
  logoUrl?: string;
  websiteUrl?: string;
  privacyPolicyUrl?: string;
  mcpUrl?: string;
  mcpAppId?: number;
  clientId?: string;
  requiredScopes: Default<string[]>;
};

export type McpServerByAuthenticatorIdRequest = { authenticatorId: string };

export type McpServerByIdRequest = { id: number };

export type McpServerListRequest = {};

export type McpServerLogoUrlsRequest = { mcpServerIds: Default<number[]> };

export type McpServerSortDirection = 'ASC' | 'DESC' | unhandledEnumCase;

export type McpServerSortField =
  | 'NAME'
  | 'ID'
  | 'CONNECTED_FIRST'
  | unhandledEnumCase;

export type McpServersAvailableToPortalPaginatedRequest = {
  search?: string;
  after: Default<number>;
  offset: Default<number>;
  limit: number;
  sortBy: Default<McpServerSortField>;
  sortDirection: Default<McpServerSortDirection>;
};

export type McpServersAvailableToPortalRequest = { search?: string };

export type McpServersByAppIdRequest = { appId: number };

export type McpServerListResponse = { mcpServers: Default<McpServer[]> };

export type McpServerLogoUrl = {
  id: number;
  authenticatorId: string;
  logoUrl?: string;
};

export type McpServerLogoUrlsResponse = {
  serverLogoUrls: Default<McpServerLogoUrl[]>;
};

export type McpServerPageResponse = {
  hasMore: boolean;
  mcpServers: Default<McpServer[]>;
};

export type McpServerResponse = { mcpServer?: McpServer };

export type GetMcpServerByIdRequestType = Requestify<McpServerByIdRequest>;
export type GetMcpServerByIdResponseType = McpServerResponse;
export type GetMcpServerByIdErrorType = McpRegistryError & HubspotMetadata;
export const getMcpServerByIdRpc: ChirpAvroRpcDetails<
  GetMcpServerByIdRequestType,
  GetMcpServerByIdResponseType,
  GetMcpServerByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServerById',
  auth: 'app',
  fingerprint: '35etkYBEAT9FZ8eGoUR1q8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServersRequestType = Requestify<McpServerListRequest>;
export type GetMcpServersResponseType = McpServerListResponse;
export type GetMcpServersErrorType = McpRegistryError & HubspotMetadata;
export const getMcpServersRpc: ChirpAvroRpcDetails<
  GetMcpServersRequestType,
  GetMcpServersResponseType,
  GetMcpServersErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServers',
  auth: 'app',
  fingerprint: 'OIROYkaHPXGdybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServersByAuthenticatorIdRequestType =
  Requestify<McpServerByAuthenticatorIdRequest>;
export type GetMcpServersByAuthenticatorIdResponseType = McpServerListResponse;
export type GetMcpServersByAuthenticatorIdErrorType = McpRegistryError &
  HubspotMetadata;
export const getMcpServersByAuthenticatorIdRpc: ChirpAvroRpcDetails<
  GetMcpServersByAuthenticatorIdRequestType,
  GetMcpServersByAuthenticatorIdResponseType,
  GetMcpServersByAuthenticatorIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersByAuthenticatorId',
  auth: 'app',
  fingerprint: 'Ctdnmd9oG8KdybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServerLogosRequestType = Requestify<McpServerLogoUrlsRequest>;
export type GetMcpServerLogosResponseType = McpServerLogoUrlsResponse;
export type GetMcpServerLogosErrorType = McpRegistryError & HubspotMetadata;
export const getMcpServerLogosRpc: ChirpAvroRpcDetails<
  GetMcpServerLogosRequestType,
  GetMcpServerLogosResponseType,
  GetMcpServerLogosErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServerLogos',
  auth: 'app',
  fingerprint: 'SfCf4RDFamUdW_jR30YWAskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServersAvailableToPortalRequestType =
  Requestify<McpServersAvailableToPortalRequest>;
export type GetMcpServersAvailableToPortalResponseType = McpServerListResponse;
export type GetMcpServersAvailableToPortalErrorType = McpRegistryError &
  HubspotMetadata;
export const getMcpServersAvailableToPortalRpc: ChirpAvroRpcDetails<
  GetMcpServersAvailableToPortalRequestType,
  GetMcpServersAvailableToPortalResponseType,
  GetMcpServersAvailableToPortalErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersAvailableToPortal',
  auth: 'app',
  fingerprint: '9NQZKNIFY6edybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServersByAppIdRequestType =
  Requestify<McpServersByAppIdRequest>;
export type GetMcpServersByAppIdResponseType = McpServerListResponse;
export type GetMcpServersByAppIdErrorType = McpRegistryError & HubspotMetadata;
export const getMcpServersByAppIdRpc: ChirpAvroRpcDetails<
  GetMcpServersByAppIdRequestType,
  GetMcpServersByAppIdResponseType,
  GetMcpServersByAppIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersByAppId',
  auth: 'app',
  fingerprint: 'v7m0kZM0NsadybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServersAvailableToPortalPaginatedRequestType =
  Requestify<McpServersAvailableToPortalPaginatedRequest>;
export type GetMcpServersAvailableToPortalPaginatedResponseType =
  McpServerPageResponse;
export type GetMcpServersAvailableToPortalPaginatedErrorType =
  McpRegistryError & HubspotMetadata;
export const getMcpServersAvailableToPortalPaginatedRpc: ChirpAvroRpcDetails<
  GetMcpServersAvailableToPortalPaginatedRequestType,
  GetMcpServersAvailableToPortalPaginatedResponseType,
  GetMcpServersAvailableToPortalPaginatedErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersAvailableToPortalPaginated',
  auth: 'app',
  fingerprint: 'JpnG1PKyJEcWRZ8SSxTflckRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
